var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"play-btn",class:_vm.data.staticClass},_vm.listeners),[_c('BaseSvg',{attrs:{"name":"ico-play-fill"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }